import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { CYCLE, firstDelayAt, PHASE_NACELLES } from '../bosses/heraut.cycle';
import { defineEnemy, Motion, Pattern } from '../schema';

/** B01-c — NACELLE DU HÉRAUT. Partie destructible, montée par paire (±58 u).
 *
 *  ── Rôle : la porte d'entrée ──
 *  520 PV, la partie la moins chère du boss, et la plus proche du noyau. C'est
 *  celle que le joueur tue en premier sans y penser, simplement parce qu'elle
 *  se trouve sous son tir quand il découvre que le noyau est intouchable.
 *
 *  Cette découverte est le vrai travail de la nacelle. Le blindage par les
 *  parties ne s'explique nulle part dans l'interface : le joueur tire au centre,
 *  rien ne se passe, il tire à côté, quelque chose meurt. Il faut que la
 *  première partie qui cède soit à portée immédiate de cette erreur, sinon la
 *  leçon coûte dix secondes de confusion au lieu d'une.
 *
 *  ── Anneau ──
 *  Douze projectiles à 300 u/s, la plus lente émission du combat. La moitié
 *  supérieure de l'anneau part vers le haut et sort du cadre sans jamais
 *  menacer personne : ce n'est pas du gaspillage, c'est la SILHOUETTE. Un
 *  anneau complet se lit comme une pulsation du vaisseau, là où un demi-cercle
 *  se lirait comme une arme de plus.
 *
 *  `stepDeg` fait tourner l'anneau de 15° d'un cycle à l'autre, pour que deux
 *  pulsations successives ne se superposent jamais et que les couloirs de
 *  passage se déplacent. Sans cette rotation, le joueur mémoriserait une place
 *  sûre et s'y installerait — la figure cesserait d'être une figure. */
export default defineEnemy({
  id: 'heraut-nacelle',
  // Standard et non Heavy, bien qu'elle ait 520 PV : le rang ne mesure pas la
  // résistance, il dose le gel et la secousse à la mort (PLAN.md §6.2). Six
  // parties qui meurent en quelques secondes avec un hitstop lourd chacune
  // hacheraient la fin de la phase de démontage.
  rank: Rank.Standard,
  hp: 520,
  visualRadius: 22,
  score: 450,
  telegraph: 2.2,
  drops: 2,
  motion: { kind: Motion.Hover, speed: 0, amplitude: 0, frequency: 0, holdY: 330 },
  emitter: {
    pattern: Pattern.Ring,
    every: CYCLE,
    count: 12,
    spreadDeg: 0,
    speed: 300,
    stepDeg: 15,
    firstDelay: firstDelayAt(PHASE_NACELLES),
    family: Fam.EnemyRed,
  },
});
